﻿import EventHandler from './EventHandler';

export default class SubmitForm extends EventHandler {
    private _root: HTMLFormElement;
    private _provinces: HTMLElement;
    private _provincesInitial: string;
    private _cities: HTMLElement;
    private _citiesInitial: string;
    private _categories: HTMLElement;
    private _isOpen: boolean;
    private _fomDropZone: any;
    private _dropZonePreviewTemplate: string;

    constructor() {
        super();
       
        this._root = document.querySelector('#submit-form');

        if (this._root == null)
            return;

        this._provinces = this._root.querySelector('[name="ProvinceId"]');
        this._provincesInitial = $(this._provinces).html();
        this._cities = this._root.querySelector('[name="CityId"]');
        this._citiesInitial = $(this._cities).html();
        this._categories = this._root.querySelector('[name="CategoryId"]');

        this._dropZonePreviewTemplate = document.querySelector("#dropzone-preview-template").innerHTML;

        /*
        ($([this._cities, this._provinces]) as any).selectpicker({
            size: 10
        });
        */

        this.bind();

        this.loadProvinces();
        this.loadCities();
    }

    private bind() {

        // this._toggler.addEventListener('click', () => this.toggle());
        this._provinces.addEventListener('change', (e) => {
            //this.loadCities($(e.target).val().toString());
        });

        $(document).ready(() => { // kell a ready
            this.initDropZone();
        });

        $(this._root).on("submit", (e) => {
            e.preventDefault();
            $(".success-upload", this._root).hide();

            if (!this.validate())
                return;

            $.post(
                "/Submit/Do",
                $(e.target).serializeArray(),
                (response) => {                    
                    this.updateValidationClasses(response);
                    if (response.Status == "ok") {
                        this.resetForm(response.NewGallery);
                        // this.trigger("submit.success");
                        $(".success-upload", this._root).css("display", "flex");
                    }
                },
                "json"
            );
        });

        // dropzone kattintás bugfix
        $('.submit-form__dropzone-attach-icon, .submit-form__dropzone-attach-text').on('click', () => $('.submit-form__dropzone-attach').trigger('click'));
    }

    showError($element, message) {
        $element.closest(".footer__input-wrap").addClass("input-error"); // inputos felkiáltójel
        $element.closest(".search__selectpicker-wrap").addClass("input-error"); // comboboxos felkiáltójel
        $element.html(message);
        $element.show();
    }

    isEmailAddress(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validate() {
        let $scrollTo = null;
        $("[data-fom-errormessage]", this._root).closest(".input-error").removeClass("input-error");
        $("[data-fom-errormessage]", this._root).hide();
        $("[data-fom-validate]", this._root).each((i, e) => {
            let $errorElement = $("[data-fom-errormessage=\"" + $(e).data("fom-validate") + "\"]", this._root);

            // required
            if (typeof $(e).data("fom-required") !== "undefined" && $(e).val() == "") {                
                this.showError($errorElement, $(e).data("fom-required-error"));
                $scrollTo = $scrollTo === null ? $(e) : $scrollTo; // csak ha még nem volt értéke
                return; // következő mező
            }

            // email
            if (typeof $(e).data("fom-email") !== "undefined" && !this.isEmailAddress($(e).val())) {
                this.showError($errorElement, $(e).data("fom-email-error"));                    
                $scrollTo = $scrollTo === null ? $(e) : $scrollTo; // csak ha még nem volt értéke
                return; // következő mező                
            }

        });
        if ($scrollTo !== null)
            $("html, body").animate({ "scrollTop": $scrollTo.offset().top  - 130 });
        return $scrollTo === null; // nem volt hiba: true
    }

    loadProvinces() {
        $.get(
            "/Search/AllProvinces",
            (response) => {
                $(this._provinces).html(this._provincesInitial);
                for (let i in response.provinces) {
                    $(this._provinces).append("<option value=\"" + response.provinces[i].id + "\">" + response.provinces[i].name + "</option>");
                }
                ($(this._provinces) as any).selectpicker("refresh");
            }
        );
    }

    loadCities(provinceId?: string) {

        let data: any = {};
        if (typeof provinceId !== "undefined" && provinceId != "")
            data.provinceId = provinceId;
        $.get(
            "/Search/AllCities",
            data,
            (response) => {
                $(this._cities).html(this._citiesInitial);
                for (let i in response.cities) {
                    $(this._cities).append("<option value=\"" + response.cities[i].id + "\">" + response.cities[i].name + "</option>");
                }
                ($(this._cities) as any).selectpicker("refresh");
            }
        );

    }

    initDropZone() {
        this._fomDropZone = new (window as any).FomDropZone(
            // wrapper options
            {
                "selector": "#fom-dropzone-upload",
                "dropzoneSelector": "#frontend-dropzone",
            },
            // dropzone options
            {
                "params": {
                    "guid": $("#fom-dropzone-upload").data("config").guid
                },
                "addRemoveLinks": false,
                "maxFiles": 3,
                "previewsContainer": '.submit-form__dropzone-previews',
                "thumbnailWidth": null,
                "acceptedFiles": "image/jpeg",
                "previewTemplate": this._dropZonePreviewTemplate,                
                "uploadprogress": (file, progress, bytesSent) => {
                    console.log("progress=" + progress);
                    if (progress != 100) {
                        $(".mode-remove", file.previewElement).hide();                        
                        $(".progress-bar", file.previewElement).attr("class", "progress-bar p" + Math.floor(progress));
                        $(".progress-bar", file.previewElement).show();                        
                    } else {
                        $(".progress-bar", file.previewElement).hide();
                        $(".mode-remove", file.previewElement).show();
                    }
                },
                "error": function (file, message, xhr) {
                    $(file.previewElement).remove();
                },
            }
        );
        this._fomDropZone.Init();
    }

    updateValidationClasses(response: any) {
        for (let key in response) {
            if (key == "Status" || key == "NewGallery")
                continue;
            let $inputContainer = $('[name="' + key + '"]', $('.submit-form .user-form')).closest('.user-form__field');
            if (response[key] == "ok") {
                $inputContainer.removeClass("user-form__field--error");
                $inputContainer.addClass("user-form__field--valid");
            } else {
                $inputContainer.removeClass("user-form__field--valid");
                $inputContainer.addClass("user-form__field--error");
            }
        }
    }

    resetForm(newGallery: any) { // ez submit után hívható csak, indításkor nem, mert akkor a dropzone még nincs idegállapotban
        this._root.reset();
        $('.submit-form .user-form .user-form__field--valid').removeClass('user-form__field--valid');
        $('.submit-form .user-form .user-form__field--error').removeClass('user-form__field--error');
        this.loadProvinces();
        this.loadCities();
        ($(this._categories) as any).selectpicker("refresh");        

        this._fomDropZone.Reset(); // leveszi az összes preview-t
        this._fomDropZone.GetDzInstance().destroy(); // leakasztja az elemről a dropzone-t
        $('.submit-form .user-form [name="GalleryGuid"]').val(newGallery.Guid); // beállítja a hidden inputot az új GalleryGuid-ra
        $('#fom-dropzone-upload').attr("data-config", newGallery.Config); // beállítja a dropzone elem új configját
        $('#fom-dropzone-upload').removeData(); // törli a jquery "data" cache-t
        this.initDropZone(); // ráakasztja a dropzone-t az elemre
        $("[type=\"submit\"]", this._root).attr("disabled", "disabled");
    }    
}
